import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select, Typography, useTable } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { SearchDifficultLevelDuplicate } from 'gql/query'
import { IDifficultyLevel } from 'interfaces'
import { useEffect, useState } from 'react'

type CreateDifficultLevelProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateDifficultyLevel: React.FC<CreateDifficultLevelProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  const metaData = {
    fields: ['id', 'name', 'order', 'created_at'],
  }
  //   const { data: testTrackListData } = useList({ resource: 'test_tracks', metaData: { fields: ['id', 'grade_ids'] } })

  const [error, setError] = useState(false)
  //   const [type, setType] = useState('')
  //   const [order, setOrder] = useState<number>(0)
  const [data, setData] = useState([] as any[])
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    console.log({ values })
    if (!error) {
      return (
        formProps?.onFinish &&
        formProps?.onFinish({
          ...values,
        })
      )
    }
  }

  const checkDuplicates = async (text: any) => {
    SearchDifficultLevelDuplicate(parseInt(text)).then((resp: any) => {
      // console.log({ resp?.blooms_levels })
      if (resp?.difficulty_levels?.length > 0) {
        setError(true)
      } else {
        setError(false)
      }
    })
  }
  //   console.log(order)
  return (
    <Modal
      {...modalProps}
      title="Create Difficulty Level"
      okButtonProps={{
        hidden: error,
        onClick: formProps?.form?.submit,
      }}
    >
      <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('difficulty_levels', 'create', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        {/* <Form.Item
          label="Medium"
          name="medium_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...mediumSelectProps} />
        </Form.Item> */}
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Order"
          name="order"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="number" onChange={e => checkDuplicates(e?.target?.value)} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        {error ? <Typography.Text type="danger">Duplicate Found..Please enter another order</Typography.Text> : null}
      </Form>
    </Modal>
  )
}
